<div
    class="tw-w-full tw-max-w-[736px] tw-bg-[#FBFBFB] tw-h-full tw-flex tw-flex-col tw-justify-center tw-rounded-[12px] tw-shadow-lg tw-p-10 tw-relative tw-text-center tw-font-[Figtree]"
>
    <img
        class="tw-absolute tw-top-4 tw-right-4 tw-text-gray-500 hover:tw-text-black"
        [mat-dialog-close]="true"
        src="../../../../../assets/images/announcement-close.svg"
        (click)="closeDialog()"
        alt="Close announcement"
    />

    <!-- Title -->
    <h2 class="tw-text-[22px] !tw-font-bold tw-text-[#024B3F] tw-mb-4">
        Thank you for submitting your feedback!
    </h2>

    <!-- Description -->
    <p
        class="tw-text-[16px] tw-text-gray-600 !tw-mb-7"
        *ngIf="!isAuthenticated; else authenticatedDesc"
    >
        We have received your feedback. Please register or login to track your
        submission.
    </p>

    <ng-template #authenticatedDesc>
        <p class="tw-text-[16px] tw-text-gray-600 !tw-mb-7">
            We have received your feedback. You can view them in your dashboard.
        </p>
    </ng-template>

    <!-- Buttons -->
    <div class="tw-flex tw-justify-center tw-gap-4">
        <ng-container *ngIf="!isAuthenticated; else authenticatedBlock">
            <button
                class="tw-px-6 tw-py-3 tw-rounded-full tw-border tw-border-[#024B3F] tw-text-[#024B3F] tw-font-semibold hover:tw-bg-[#024B3F] hover:tw-text-white tw-transition"
                (click)="goToSignIn()"
            >
                Login
            </button>
            <button
                class="tw-px-6 tw-py-3 tw-rounded-full tw-bg-[#024B3F] tw-text-white tw-font-semibold tw-transition"
                (click)="goToSignUp()"
            >
                Register Now
            </button>
        </ng-container>
        <ng-template #authenticatedBlock>
            <button
                class="tw-px-6 tw-py-3 tw-rounded-full tw-bg-[#024B3F] tw-text-white tw-font-semibold tw-transition"
                (click)="goToDashboard()"
            >
                View Now
            </button>
        </ng-template>
    </div>
</div>
